import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { Tag as Tag$2, Icon } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["responsive", "small", "onClick", "variant", "iconBefore", "iconAfter", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var variantLegacyConverter = function variantLegacyConverter(variant) {
  var dict = {
    success: 'success',
    error: 'error',
    info: 'info',
    ksp: 'ksp',
    sale: 'sale',
    basic: 'basic',
    alert: 'alert',
    black: 'basic',
    'light-sand': 'ksp',
    'quartz': 'ksp',
    'red': 'sale',
    'red-inverted': 'sale',
    'green': 'success'
  };
  return dict[variant] || 'basic';
};

/**
 * Tag component - Renders a styled tag element that can include icons and support different variants.
 * If onClick is provided, renders as a button element.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.children - The text content of the tag.
 * @param {boolean} [props.responsive=false] - Whether the tag should adjust size between mobile/desktop.
 * @param {boolean} [props.small=false] - Whether to use the small variant of the tag.
 * @param {import('react').MouseEventHandler} [props.onClick] - Click handler. When provided, renders as a button element.
 * @param {'basic'|'sale'|'ksp'|'success'|'error'|'alert'|'info'} [props.variant='basic'] - Visual style variant.
 * @param {React.ReactNode} [props.iconBefore] - Icon element to display before the text.
 * @param {React.ReactNode} [props.iconAfter] - Icon element to display after the text.
 * @param {Object} [props.rest] - Additional props passed to the root element.
 * @returns {JSX.Element} The rendered Tag component.
 */
var Tag = function Tag(_ref) {
  var _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'basic' : _ref$variant,
    _ref$iconBefore = _ref.iconBefore,
    iconBefore = _ref$iconBefore === void 0 ? null : _ref$iconBefore,
    _ref$iconAfter = _ref.iconAfter,
    iconAfter = _ref$iconAfter === void 0 ? null : _ref$iconAfter,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Tag$2, _objectSpread(_objectSpread({
    onClick: onClick,
    type: onClick ? 'button' : undefined,
    as: onClick ? 'button' : undefined,
    $variant: variantLegacyConverter(variant),
    $responsive: responsive,
    $small: small
  }, rest), {}, {
    children: [/*#__PURE__*/React.isValidElement(iconBefore) && /*#__PURE__*/jsx(Icon, {
      children: /*#__PURE__*/React.cloneElement(iconBefore, {
        size: 'xxxs'
      })
    }), children, /*#__PURE__*/React.isValidElement(iconAfter) && /*#__PURE__*/jsx(Icon, {
      children: /*#__PURE__*/React.cloneElement(iconAfter, {
        size: 'xxxs'
      })
    })]
  }));
};
var Tag$1 = Tag;

export { Tag$1 as default };
//# sourceMappingURL=Tag.js.map
